<div class="dx-card wide-card">
    <h4 class="content-block ap-green">O2 Portal ASU Reference List</h4>
    <dx-data-grid class="fixGridHeight" id="O2PortalASUReferenceListGrid" [dataSource]="o2PortalASUReferenceListData"
        [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="false" [columnAutoWidth]="true"
        [rowAlternationEnabled]="true">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
                </dx-button>
                <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                    (onClick)="exportExcel($event)">
                </dx-button>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
            [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>

        <dxi-column dataField="siteId" [visible]="false"></dxi-column>
        <dxi-column dataField="gasCompany" caption="Competitor"></dxi-column>
        <dxi-column dataField="startUpYear" caption="Start Up Year" [width]="90"></dxi-column>
        <dxi-column dataField="country" caption="Country" [width]="90"></dxi-column>
        <dxi-column dataField="province" caption="State/Province"></dxi-column>
        <dxi-column dataField="city" caption="City" [width]="90"></dxi-column>
        <dxi-column dataField="customer" caption="Customer"></dxi-column>
        <dxi-column dataField="businessModel" caption="Business Model" [width]="100"></dxi-column>
        <dxi-column dataField="plantBuilder" caption="Plant Builder"></dxi-column>
        <dxi-column dataField="numberOfAsus" caption="Number ASUs" [width]="100"></dxi-column>
        <dxi-column dataField="goxperAsu" caption="GOX /ASU (MTD)" [width]="80">
            <dxo-format [precision]="1">
            </dxo-format>
        </dxi-column>
        <dxi-column dataField="ganperAsu" caption="GAN /ASU (MTD)" [width]="80">
            <dxo-format [precision]="1">
            </dxo-format>
        </dxi-column>
        <dxi-column dataField="loxperAsu" caption="LOX /ASU (MTD)" [width]="80">
            <dxo-format [precision]="1">
            </dxo-format>
        </dxi-column>
        <dxi-column dataField="linperAsu" caption="LIN /ASU (MTD)" [width]="80">
            <dxo-format [precision]="1">
            </dxo-format>
        </dxi-column>
        <dxi-column dataField="endMarket" caption="End Market" [width]="100"></dxi-column>
        <dxi-column dataField="status" caption="Status" [width]="100"></dxi-column>
        <dxi-column dataField="awardYear" caption="Award Year"></dxi-column>
        <dxi-column dataField="productionFacilityID" caption="Facility ID" width="100"></dxi-column>
    </dx-data-grid>

    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>